export const environment = {
  production: false,
  apiUrl: 'http://dashapi.hitarget.ai'
  // apiUrl: 'https://devapi.hitarget.ai'
};
